import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';

// PrimeNG imports
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

import { UserAccountClient } from './../models/models.swagger.generated';
import { SpinnerService } from './../spinner/spinner.service';
import { ToastService } from './../services/toast.service';
import { AppErrorMessagesService } from '../services/app-error-messages.service';
import { ErrorType } from 'src/app/core/routing/error-types';
import { loginRoute } from 'src/app/core/routing/route-names';
import { AppErrorMessagesComponent } from '../error-messages/app-error-messages.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        ReactiveFormsModule,
        RouterLink,
        TranslateModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        AppErrorMessagesComponent
    ]
})
export class ForgotPasswordComponent implements OnInit {
    public forgotPasswordForm: FormGroup<{userName: FormControl}>;
    public forgotPasswordSuccess = false;
    public loginRoute = loginRoute;

    constructor(
        private formBuilder: FormBuilder,
        private userAccountClient: UserAccountClient,
        private spinnerService: SpinnerService,
        private toastService: ToastService,
        private errorMessageService: AppErrorMessagesService
    ) { }

    public get formFields() {
        return this.forgotPasswordForm.controls;
    }

    public formSubmit() {
        if (this.forgotPasswordForm.valid) {
            this.spinnerService.showSpinner = true;
            const userName = this.forgotPasswordForm.value.userName;

            this.userAccountClient.forgotPassword({ username: userName } as any).pipe(
                tap(() => {
                    this.spinnerService.showSpinner = false;
                    this.forgotPasswordSuccess = true;
                }),
                catchError((error: any) => {
                    this.spinnerService.showSpinner = false;
                    this.handleError(error);
                    return of(error);
                })
            ).subscribe();
        }
    }

    private handleError(error: any) {
        const apiErrorCode = this.errorMessageService.getApiErrorCode(error);
        let i18nErrorMessage = 'i18n.errors.server-error.message';
        const i18nErrorTitle = 'i18n.errors.server-error.title';

        if (apiErrorCode) {
            i18nErrorMessage = 'i18n.base.forgot-password.errors.' + apiErrorCode;
        }

        this.toastService.showError(
            i18nErrorTitle,
            i18nErrorMessage,
            null,
            ErrorType.serverError
        );
    }

    ngOnInit() {
        this.forgotPasswordForm = this.formBuilder.group({
            userName: this.formBuilder.control(null, Validators.required)
        });
    }
}

